import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["captain", "mate", "angler", "person", "role", "selection", "count", "warning", "search", "empty"]
  static values = { limit: Number }

  connect() {
    this.update()
    this.filter()
  }

  update() {
    const count = this.anglerTargets.filter(input => input.checked).length
    this.countTarget.textContent = this.limitValue > 0
      ? `${count} of ${this.limitValue} anglers selected`
      : `${count} ${count === 1 ? "angler" : "anglers"} selected`

    const excess = this.limitValue > 0 ? count - this.limitValue : 0
    this.warningTarget.hidden = excess <= 0
    this.warningTarget.textContent = excess > 0
      ? `Remove ${excess} ${excess === 1 ? "angler" : "anglers"} to meet the tournament limit.` : ""

    this.roleTargets.forEach(role => {
      const id = role.dataset.personId
      role.textContent = id === this.captainTarget.value ? " · Tournament captain"
        : id === this.mateTarget.value ? " · Tournament mate" : ""
    })
    this.anglerTargets.forEach((input, index) => {
      this.selectionTargets[index].textContent = input.checked ? "Selected to fish" : "Not selected to fish"
    })
  }

  filter() {
    const query = this.hasSearchTarget ? this.searchTarget.value.trim().toLocaleLowerCase() : ""
    this.personTargets.forEach(person => { person.hidden = !person.dataset.personName.includes(query) })
    this.emptyTarget.hidden = this.personTargets.length === 0 || this.personTargets.some(person => !person.hidden)
  }
}
